import React, { useEffect, useState,useContext } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Checkbox,
  IconButton,
  Tooltip,
  Button,
  Alert
} from '@mui/material';
import { Badge } from '@mui/material';
import { Visibility, Edit, Delete, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import contribuenteApi from '../../api/contribuenteApi';
import documentoApi from '../../api/documentoApi';
import scadenzaApi from '../../api/scadenzaApi';
import filesApi from '../../api/filesApi';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../../components/ConfirmDeleteModal';
import { scadenzaStatusMap } from '../../utils/scadenzaStatusMapper';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';

export default function ContribuenteDetailPageDesktop() {
  const { id } = useParams();
  const [contribuente, setContribuente] = useState(null);
  const { user } = useContext(AuthContext);
  const [docs, setDocs] = useState([]);
  const [docsPage, setDocsPage] = useState(0);
  const [docsTotalPages, setDocsTotalPages] = useState(0);
  const [sortField, setSortField] = useState('dataCreazione');
  const [sortDirection, setSortDirection] = useState('DESC'); // ASC o DESC

  const [scadenze, setScadenze] = useState([]);
  const [scadPage, setScadPage] = useState(0);
  const [scadTotalPages, setScadTotalPages] = useState(0);

  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteType, setDeleteType] = useState(''); // 'doc' o 'scad'
  const [selectedDocumentIds, setSelectedDocumentIds] = useState([]);
  const [mergeError, setMergeError] = useState(null);
  const [merging, setMerging] = useState(false);
  const navigate = useNavigate();
  const [err, setErr] = useState(null);
  const pageSize = 10;
  console.log('localStorage.token', localStorage.getItem('token'));
  console.log('AuthContext.token', useContext(AuthContext).token);
  useEffect(() => {
    fetchContribuente();
    fetchDocs(0);
    fetchScadenze(0);
  }, [id,sortField, sortDirection]);

  const fetchContribuente = () => {
    contribuenteApi.get(id)
      .then(r => setContribuente(r.data))
      .catch(err =>
      setErr(extractErrorMessage(err)));
  };

  const fetchDocs = (page) => {
      const params = { page, size: pageSize, sort: `${sortField},${sortDirection}` };
    documentoApi.listbycontribuente(id, params)
      .then(r => {
        setDocs(r.data.content || []);
        setDocsTotalPages(r.data.totalPages || 0);
        setDocsPage(r.data.number || 0);
      })
      .catch(err =>
      setErr(extractErrorMessage(err)));
  };

  const fetchScadenze = (page) => {
    scadenzaApi.listbycontribuente(id, { page, size: pageSize })
      .then(r => {
        setScadenze(r.data.content || []);
        setScadTotalPages(r.data.totalPages || 0);
        setScadPage(r.data.number || 0);
      })
      .catch(err =>
      setErr(extractErrorMessage(err)));
  };

  const confirmDelete = (id, type) => {
    setSelectedId(id);
    setDeleteType(type);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      if (deleteType === 'doc') {
        await documentoApi.delete(selectedId);
        fetchDocs(docsPage);
        fetchScadenze(scadPage);
      } else if (deleteType === 'scad') {
        await scadenzaApi.delete(selectedId);
        fetchScadenze(scadPage);
      }
    } catch (e) {
      console.error("Errore eliminazione:", e);
      setErr(extractErrorMessage(e));
    } finally {
      setOpenDelete(false);
      setSelectedId(null);
      setDeleteType('');
    }
  };

    const handleSort = (field) => {
      if (sortField === field) {
        setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
      } else {
        setSortField(field);
        setSortDirection('ASC');
      }
    };

    const renderSortIcon = (field) => {
      if (sortField !== field) return null;
      return sortDirection === 'ASC' ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />;
    };

          // --- SELEZIONE E MERGE ---
          const toggleSelection = (id) => {
            setSelectedDocumentIds(prev =>
              prev.includes(id)
                ? prev.filter(x => x !== id)
                : [...prev, id]
            );
          };
          const canMerge = () => {
            if (selectedDocumentIds.length < 2) return false;

            const selectedDocs = docs.filter(d =>
              selectedDocumentIds.includes(d.id)
            );

            const first = selectedDocs[0];
            return selectedDocs.every(d =>
              d.contribuente.id === first.contribuente.id &&
              d.tipo === first.tipo &&
              d.numeroDocumento === first.numeroDocumento
            );
          };

            const handleMerge = async () => {
              setMergeError(null);
              setMerging(true);
              try {
                await documentoApi.mergeDocumenti(selectedDocumentIds);
                setSelectedDocumentIds([]);
                fetchDocs(docsPage);
              } catch (e) {
                setMergeError(e.response?.data?.error || e.response?.data || 'Errore durante il merge dei documenti');
                if(
                e.response?.data?.error!="I documenti non appartengono allo stesso contribuente" &&
                e.response?.data?.error!="Tipologia dei documenti non compatibile" &&
                e.response?.data?.error!="I documento non hanno lo stesso identificativo di atto/pratica" &&
                e.response?.data?.error!="Servono almeno due documenti"){
                  setSelectedDocumentIds([]);
                  fetchDocs(docsPage);
                }
              } finally {
                setMerging(false);
              }
            };
            // --- /SELEZIONE E MERGE ---

  if (!contribuente) return <div>Loading...</div>;

  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h4">{contribuente.nome} {contribuente.cognome}</Typography>

      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Typography>Codice Fiscale: {contribuente.codiceFiscale}</Typography>
          <Typography>Partita IVA: {contribuente.partitaIVA}</Typography>
          <Typography>Email: {contribuente.email}</Typography>
          <Typography>Telefono: {contribuente.telefono || 'N/A'}</Typography>
          <Typography>Indirizzo: {contribuente.indirizzo || 'N/A'}</Typography>
          <Typography>Regime fiscale: {contribuente.regimeFiscale}</Typography>
    {/* Bottone per upload PDF generico (potresti anche metterlo per ogni documento) */}
    <ProtectedAction user={user} contractState={user.statoContratto}>
    <Button variant="outlined" color="secondary" onClick={() => navigate(`/contribuenti/${id}/documenti/upload`)}>
      Upload PDF
    </Button></ProtectedAction>
        {user?.role !== 'ADMIN' && (
            <Button variant="outlined" color="secondary"
            onClick={() => navigate(`/contribuenti/report/${id}`)}>
              Crea Report
            </Button>
        )}

        <Button variant="outlined" onClick={() => navigate(`/contribuente/${id}/fascicolo`)}>
          Visualizza Fascicolo
        </Button>
        </CardContent>
      </Card>
        {/* Bottone merge */}
        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <ProtectedAction user={user} contractState={user.statoContratto}>
            <Button
              variant="contained"
              color="warning"
              disabled={!canMerge() || merging}
              onClick={handleMerge}
            >
              Unisci documenti selezionati
            </Button>
          </ProtectedAction>
        </Stack>

        {mergeError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {typeof mergeError==='string' ? mergeError : JSON.stringify(mergeError)}
          </Alert>
        )}
      {/* Documenti */}
      <Typography variant="h6" sx={{ mt: 2 }}>Documenti</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell onClick={() => handleSort('tipo')} style={{ cursor: 'pointer' }}>
            Tipo {renderSortIcon('tipo')}</TableCell>
            <TableCell>Numero documento</TableCell>
            <TableCell>Descrizione</TableCell>
            <TableCell onClick={() => handleSort('dataCreazione')} style={{ cursor: 'pointer' }}>
            Data creazione {renderSortIcon('dataCreazione')}</TableCell>
            <TableCell>Rate saltate</TableCell>
            <TableCell style={{ cursor: 'pointer' }}>
              Decaduto
            </TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {docs.map(d => (
            <TableRow key={d.id}>
              <TableCell>{d.tipo}</TableCell>
              <TableCell>{d.numeroDocumento}</TableCell>
              <TableCell>{d.descrizione}</TableCell>
              <TableCell>{formatDate(d.dataCreazione)}</TableCell>
      <TableCell>
        {d.rateSaltate > 0 ? (
          <Badge color="error" badgeContent={d.rateSaltate}>
            <span></span>
          </Badge>
        ) : (
          <span>{d.rateSaltate}</span>
        )}
      </TableCell>
      <TableCell>{d.decaduta?'SI':'NO'}</TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  <IconButton color="primary" size="small" onClick={() => navigate(`/documenti/${d.id}`)}><Visibility /></IconButton>
                  <ProtectedAction user={user} contractState={user.statoContratto}>
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/documenti/edit/${d.id}`)}><Edit /></IconButton>
                  <IconButton color="error" size="small" onClick={() => confirmDelete(d.id, 'doc')}><Delete /></IconButton>
                 <Tooltip title="seleziona per merge">
                          <Checkbox
                            checked={selectedDocumentIds.includes(d.id)}
                            onChange={() => toggleSelection(d.id)}
                          />
                 </Tooltip>
                  </ProtectedAction>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        {Array.from({ length: docsTotalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === docsPage ? "contained" : "outlined"}
            onClick={() => fetchDocs(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>

      {/* Scadenze */}
      <Typography variant="h6" sx={{ mt: 2 }}>Scadenze</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Tipo</TableCell>
            <TableCell>Data</TableCell>
            <TableCell>Codice pagamento</TableCell>
            <TableCell>Importo</TableCell>
            <TableCell>Stato</TableCell>
            <TableCell>Data pagamento</TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {scadenze.map(s => (
            <TableRow key={s.id}>
              <TableCell>{s.tipo}</TableCell>
              <TableCell>{s.dataScadenza}</TableCell>
              <TableCell>{s.codiceModuloPagamento}</TableCell>
              <TableCell>{s.importo}</TableCell>
               <TableCell>{s.stato}</TableCell>
               <TableCell>{s.dataPagamento}</TableCell>
              <TableCell>
                <Stack direction="row" spacing={1}>
                  <IconButton color="primary" size="small" onClick={() => navigate(`/scadenze/${s.id}`)}><Visibility /></IconButton>
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/scadenze/edit/${s.id}`)}><Edit /></IconButton>
                  <IconButton color="error" size="small" onClick={() => confirmDelete(s.id, 'scad')}><Delete /></IconButton>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        {Array.from({ length: scadTotalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === scadPage ? "contained" : "outlined"}
            onClick={() => fetchScadenze(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>

      <ConfirmDialog
        open={openDelete}
        onCancel={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        title="Conferma Eliminazione"
        message="Sei sicuro di voler eliminare questo elemento?"
      />
    </Container>
  );
}